import type { SxProps, Theme } from '@mui/material';

const SKILLSET_BLUE = '#098beb';
const SKILLSET_HEADER_BLUE = '#dff2ff';

export const skillsetStyles = {
  shell: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: '100%',
    minWidth: 0,
    overflow: 'hidden',
    background: theme.palette.background.paper,
  }) as SxProps<Theme>,
  content: () =>
    ({
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      minHeight: 0,
      minWidth: 0,
      overflow: 'hidden',
    }) as SxProps<Theme>,
  header: () =>
    ({
      flex: '0 0 auto',
      display: 'grid',
      alignItems: 'center',
      padding: '12px 18px',
      background: SKILLSET_HEADER_BLUE,
    }) as SxProps<Theme>,
  headerTitle: () =>
    ({
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      minWidth: 0,
    }) as SxProps<Theme>,
  headerIcon: () =>
    ({
      width: '54px',
      height: '54px',
      flex: '0 0 auto',
      display: 'grid',
      placeItems: 'center',
      borderRadius: '999px',
      background: '#ffffff',
      color: SKILLSET_BLUE,
      '& .MuiSvgIcon-root': {
        width: '34px',
        height: '34px',
        fill: 'currentColor',
        stroke: 'none',
      },
    }) as SxProps<Theme>,
  title: () =>
    ({
      minWidth: 0,
      color: '#111827',
      fontSize: '24px',
      fontWeight: 300,
      lineHeight: 1.15,
      margin: 0,
      letterSpacing: 0,
    }) as SxProps<Theme>,
  detail: () =>
    ({
      flex: '1 1 auto',
      minHeight: 0,
      minWidth: 0,
      overflow: 'hidden',
      display: 'flex',
    }) as SxProps<Theme>,
  statePanel: (isError = false) =>
    ({
      display: 'grid',
      placeItems: 'center',
      minHeight: 260,
      padding: 3,
      color: isError ? 'error.main' : 'text.secondary',
      fontSize: 18,
    }) as SxProps<Theme>,
};
